import * as React from 'react';

interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
  as?: React.ElementType;
}

export const Heading = ({ as: Component = 'h2', className, children, ...props }: HeadingProps) => {
  return (
    <Component className={`${className || ''}`} {...props}>
      {children}
    </Component>
  );
};

// Get next heading level for card articles
export const getNextHeading = (heading?: string | undefined): string | undefined => {
  const match = heading?.toLowerCase().match(/h(\d)/i);
  if (match) {
    const level = parseInt(match[1]);
    return level < 6 ? `h${level + 1}` : 'h6';
  }
  return heading;
};
